export default function Input() {
  return {
    lineHeight: 2.5
  }
}
